import { render, staticRenderFns } from "./DomainsNewDomainModal.vue?vue&type=template&id=31a252e6&scoped=true"
import script from "./DomainsNewDomainModal.vue?vue&type=script&lang=js"
export * from "./DomainsNewDomainModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31a252e6",
  null
  
)

export default component.exports